const isDev = process.env.NODE_ENV === "development";

export const parentServiceUrl = isDev
  ? "https://localhost:3000"
  : "https://users.riteliberia.org";

export const childServiceUrl = isDev
  ? "https://localhost:3000"
  : "https://workflows.riteliberia.org";
